import type { ContentRow } from '../../types/content';
import type { MediaRenderer, RenderContext, RenderSlot } from './types';
import { showOnly } from './util';

// Renders a remote web page in an iframe. Example of a non-media content type:
// nothing is downloaded; the page is loaded live (so it needs connectivity).
export const urlRenderer: MediaRenderer = {
  type: 'url',
  needsMedia: false,

  async prepare(slot: RenderSlot, content: ContentRow, ctx: RenderContext): Promise<boolean> {
    const src = content.sourceUrl;
    if (!src) return false;

    showOnly(slot, 'frame');

    return await new Promise<boolean>((resolve) => {
      let settled = false;
      const done = (ok: boolean) => {
        if (settled) return;
        settled = true;
        slot.frame.onload = null;
        slot.frame.onerror = null;
        resolve(ok);
      };
      slot.frame.onload = () => done(true);
      slot.frame.onerror = () => done(false);
      slot.frame.src = src;
      // Reveal even if onload is slow or blocked (cross-origin pages still fire
      // load, but be defensive).
      setTimeout(() => done(true), ctx.firstFrameTimeoutMs);
    });
  },

  // Page is loaded after prepare(); nothing to start.
  async activate(): Promise<boolean> {
    return true;
  },
};
